import { Component, inject } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import _ from 'lodash';

import BadgeQuestion from 'entity/BadgeQuestion';

import { defaultRegistrationFields } from '../../pages/registration-form-page/registration-form-page.component';
import { RegistrationFieldQuestions } from '../../services/events.service';

@Component({
  selector: 'app-modal-add-fields',
  templateUrl: './modal-add-fields.component.html',
  styleUrl: './modal-add-fields.component.scss',
  standalone: false,
})
export class ModalAddFieldsComponent {
  private dialogRef = inject<MatDialogRef<ModalAddFieldsComponent>>(MatDialogRef);
  private data = inject<{
    registrationFields: RegistrationFieldQuestions[];
    badgeQuestions: BadgeQuestion[];
  }>(MAT_DIALOG_DATA);

  private addFieldsArray: BadgeQuestion[] = [];
  protected availableFields: RegistrationFieldQuestions[] = [];

  public constructor() {
    const registrationFields = this.data.registrationFields.map((field) => field.name);
    // TODO: DRY this up, conversion to RegistrationField is duplicated in registration-form-page.component.ts
    this.availableFields = this.data.badgeQuestions
      .map((question) => ({
        name: question.title,
        description: question.description,
        required: question.required,
        inputType: question.inputType,
        disabled: false,
      }))
      .filter((field) => !registrationFields.includes(field.name));
    defaultRegistrationFields
      .filter((field) => !registrationFields.includes(field.name))
      .forEach((field) => {
        this.availableFields.push(field);
      });
  }

  protected addRemove($event: MatCheckboxChange, badgeQuestion: BadgeQuestion) {
    if ($event.checked) {
      this.addFieldsArray.push(badgeQuestion);
    } else {
      this.addFieldsArray = this.addFieldsArray.filter((field) => field !== badgeQuestion);
    }
  }

  protected addFields() {
    this.dialogRef.close(this.addFieldsArray);
  }

  protected close() {
    this.dialogRef.close(null);
  }
}
